
import React from 'react';
import { Box } from '@mui/material';
import { colors, spacing, radius } from 'common/theme';
import { TextHot } from 'components/common/TextHot';
import { ButtonHot, BUTTON_MODE } from 'components/common/ButtonHot';
import { ModalHot } from 'components/common/ModalHot';
import { IconHot } from 'components/common/IconHot';
import TrashIcon from 'assets/personal_zone/trash.svg';
import { generateTestId } from 'app/functions';
import { useTranslations } from 'common/hooks/useTranslations';

export const DeletePaymentModal = ({
  open,
  onClose,
  onConfirm,
  lastDigits,
  isLoading = false,
  testID,
}) => {
  const { translate } = useTranslations();

  return (
    <ModalHot open={open} onClose={onClose} testID={testID}>
      {({ isMobile }) => (
        <Box
          dir="rtl"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            width: '100%',
          }}
        >
          <Box
            testId={generateTestId(testID, 'icon')}
            sx={{
              width: 112,
              height: 112,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: `${spacing.lg}px`,
            }}
          >
            <IconHot src={TrashIcon} size={112} />
          </Box>

          <TextHot
            testID={generateTestId(testID, 'title')}
            size="xxl"
            bold="bold"
            color="primary"
            sx={{ marginBottom: `${spacing.md}px` }}
          >
            {translate('delete_payment_method_title')}
          </TextHot>

          <TextHot
            testID={generateTestId(testID, 'description')}
            size="l"
            color="subtle"
            isLtr={true}
            sx={{ marginBottom: `${spacing.xl}px`, maxWidth: 320 }}
          >
            {translate('delete_payment_method_description', { lastDigits })}
          </TextHot>

          <Box
            testId={generateTestId(testID, 'buttons')}
            sx={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row-reverse',
              gap: `${spacing.sm}px`,
              width: '100%',
            }}
          >
            <ButtonHot
              testID={generateTestId(testID, 'confirm-btn')}
              mode={BUTTON_MODE.OUTLINED}
              disabled={isLoading}
              onClick={onConfirm}
              sx={{
                flex: isMobile ? 'none' : 1,
                width: isMobile ? '100%' : 'auto',
                borderRadius: `${radius.xl}px`,
                padding: `${spacing.md}px`,
                border: `1px solid ${colors.system.border.default}`,
                color: colors.system.text.primary,
              }}
            >
              {isLoading
                ? translate('delete_payment_method_loading')
                : translate('delete_payment_method_confirm')}
            </ButtonHot>

            <ButtonHot
              testID={generateTestId(testID, 'cancel-btn')}
              mode={BUTTON_MODE.PRIMARY}
              disabled={isLoading}
              onClick={onClose}
              sx={{
                flex: isMobile ? 'none' : 1,
                width: isMobile ? '100%' : 'auto',
                borderRadius: `${radius.xl}px`,
                padding: `${spacing.md}px`,
              }}
            >
              {translate('are_you_sure_modal_cancel_button_label')}
            </ButtonHot>
          </Box>
        </Box>
      )}
    </ModalHot>
  );
};

export default DeletePaymentModal;
